<template>
  <div>
    <common-subportion-status-badge
      v-if="valueIsDefined"
      :status="value"
    />
  </div>
</template>

<script>

import Vue from 'vue'
import CommonSubportionStatusBadge from '@/components/common/CommonPortionStatusBadge'

export default Vue.extend({
    name: 'CommonSubportionStatusRenderer',
    components: {
        CommonSubportionStatusBadge
    },
    computed: {
        valueIsDefined() {
            return this.params.value !== undefined
        },
        value() {
            if (this.params.isFilterCellRenderer) {
                return this.params.states.find((state) => state.code === this.params.value)
            }
            return this.params.value
        }
    }
})

</script>
